module.exports = __webpack_public_path__ + "img/keder_feuerrot_ral3000.53d7231a.jpg";